export default __webpack_public_path__ + "static/unasobrebarriga-b224aa10ae19dadfc37e4004d8d40ff1.jpg";